export class ValidationItemModel {
    name: string;
    description: string;
}
